import { Col, Form, Select } from 'antd'

import './styles.scss'
import { TFieldProps } from '..'
import { Rule } from 'antd/es/form'
import { FormState } from '@/state'
import React from 'react'

export default function EnumFormField({ fieldInfo }: TFieldProps) {
  const fieldOptions =
    fieldInfo.options?.map((item) => ({ label: `${item}`, value: item })) ?? []

  const isRequiredField = React.useMemo(() => {
    const formValues = FormState.currentFormValues.value ?? {}
    if (fieldInfo.name === 'housingProductiveActivity') {
      return Boolean(formValues.housingProductiveActivityYN)
    }

    return fieldInfo.required
  }, [FormState.currentFormValues.value, fieldInfo.required])

  const setFieldRules = React.useCallback((): Rule[] => {
    const rules: Rule[] = []

    if (isRequiredField) {
      rules.push({
        required: true,
        message: 'Este campo es obligatorio',
      })
    }

    return rules
  }, [isRequiredField])

  return (
    <Col
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
      xxl={4}
      xl={6}
      md={8}
      sm={12}
      xs={24}
    >
      <Form.Item
        className={`enum-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={isRequiredField}
        tooltip={fieldInfo.description}
        rules={setFieldRules()}
      >
        <Select
          size='small'
          allowClear
          options={fieldOptions}
          filterOption={(input, option) =>
            !!option &&
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        />
      </Form.Item>
    </Col>
  )
}
